import { Tag } from "antd/lib";
import * as React from "react";
import { useMemo } from "react";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { formatPercent } from "@/helpers";

export const ProductPercentChange = ({
  change,
  isFullPercent,
  subPrefix,
  className,
}: {
  change?: number;
  isFullPercent?: boolean;
  subPrefix?: string;
  className?: string;
}) => {
  const percent = useMemo(
    () => (change !== null && change !== undefined ? change * (isFullPercent ? 1 : 100) : 0),
    [change, isFullPercent],
  );
  const stringValue = useMemo(() => formatPercent(Math.abs(percent)), [percent]);
  const isNoChange = useMemo(() => stringValue === "0" || change === null, [change, stringValue]);

  return (
    <Tag
      className={className}
      color={
        percent === 0 || isNoChange
          ? "default"
          : percent > 0 && !isNoChange
          ? "success"
          : percent < 0 && !isNoChange
          ? "error"
          : undefined
      }
    >
      {percent > 0 && !isNoChange && (
        <>
          <CaretUpOutlined /> +
        </>
      )}
      {percent < 0 && !isNoChange && (
        <>
          <CaretDownOutlined /> -
        </>
      )}
      {change === null ? "-" : `${stringValue}${subPrefix ?? "%"}`}
    </Tag>
  );
};
